export const stripHtmlToPlainText = (value?: string) =>
  value ? value.replace(/<[^>]*>?/gm, ' ').replace(/\s+/g, ' ').trim() : '';

export const resolveContentPageHeroSubtitle = ({
  heroSubtitle,
  body,
  hasStructuredSections,
}: {
  heroSubtitle?: string;
  body?: string;
  hasStructuredSections: boolean;
}) => (hasStructuredSections ? stripHtmlToPlainText(body) : '') || heroSubtitle?.trim() || '';

export const shouldRenderStandaloneContentPageBody = ({
  body,
  hasStructuredSections,
}: {
  body?: string;
  hasStructuredSections: boolean;
}) => Boolean(body?.trim()) && !hasStructuredSections;
